import React, { useEffect, useState, useRef } from 'react';

const MediaPlayer = ({ id, vol, active, src, type, loop }) => {
    const playerRef = useRef(null);
    const [loadState, setLoadState] = useState("");



    useEffect(() => {
        const player = playerRef.current;

        // Set up interval to check loading state
        const interval = setInterval(() => {
            if (player.readyState === 4) { // HAVE_ENOUGH_DATA
                setLoadState('Playback can begin.');
                clearInterval(interval);
            } else if (player.readyState === 3) { // HAVE_FUTURE_DATA
                setLoadState('Playback can begin but more loading is recommended.');
            } else if (player.readyState === 1 || player.readyState === 2) { // HAVE_METADATA or HAVE_CURRENT_DATA
                setLoadState('Started to load');
            } else if (player.readyState === 0) { // HAVE_NOTHING
                setLoadState('No sound currently available');
            }
        }, 500); // Check every half second

        return () => {
            clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        const player = playerRef.current;

        if (active) {
            try {
                player.play();
            } catch (error) {
                console.error(`${player.id} failed to play from ${player.src}`, error);
            }
        } else {
            player.pause();
        }
    }, [active]);

    useEffect(() => {
        const player = playerRef.current;
        player.volume = vol;
    }, [vol]);

    return (
        <div className="audio-source-outer-wrapper">
            <p className="audio-load-state">{loadState}</p>
            <div className="audio-source-inner-wrapper">
                <audio id={id} src={src} ref={playerRef} type={type} loop={loop} />
            </div>
        </div>
    );
};

export default MediaPlayer;
